<template>
    <div>
        <navbar></navbar>
        <div class="__faqbg">
            <div class="container">
                <p class="__bepro">Frequently asked questions</p>
            </div>
        </div><br>
        <div class="container">
            <div class="row">
                <div class="col-md-2 col-sm-2"></div>
                <div class="col-md-8 col-sm-8">
                    <p class="__term">
                        <ul>
                            <li>Findworka Premium</li>
                            <li>Findworka Pro</li>
                            <li>Findworka Fellowship.</li>
                        </ul>
                    </p>

                    <div class="accordion __term">
                        <h4 class="accordion-toggle">1. What is Findworka?</h4>
                        <div class="accordion-content">
                            <p>
                                Findworka builds software projects and extends software teams by applying supplying development
                            </p>
                            <hr>
                        </div>
                        
                        <h4 class="accordion-toggle">2. What projects can be done on Findworka?</h4>
                        <div class="accordion-content">
                            <p>
                                Software projects. Examples include website design and development, mobile apps development (Android and iOS).
                            </p>
                            <hr>
                        </div>
                        
                        <h4 class="accordion-toggle">3. How do you charge for your development projects?</h4>
                        <div class="accordion-content">
                            <p>
                                For our software development projects, we take features and duration into consideration when we charge.
                            </p>
                            <hr>
                        </div>

                        <h4 class="accordion-toggle">4. How do you sign up Findworka Pro?</h4>
                        <div class="accordion-content">
                            <p>
                                When an intending pro fills the form on the findworka.com/pro page. Our talent team will schedule a stage 1 interview via skype. Once the applicant succeeds, the next and final round of interview will be scheduled. During the second stage of the interview, there is a stronger focus on technical depth, approach and attitude.

                            </p>
                            <hr>
                        </div>

                        <h4 class="accordion-toggle">5. How do you match your Pros?</h4>
                        <div class="accordion-content">
                            <p>
                                To hire a Pro for your contract and full-time positions, we take the project type, technology stack, duration of pro’s engagement and your budget. Our talent managers will then share your request and requirements with our pro network. Our Pros show interest and we pick the right candidate with the right blend of competence, availability and interest.
                            </p>
                            <hr>
                        </div>
                        <h4 class="accordion-toggle">6. How can I be sure that my intellectual property is safe?</h4>
                        <div class="accordion-content">
                            <p>
                                The Service Contract terms in our User Agreement states that you own any intellectual property that you pay for. You can also add additional terms to your contract with your freelancer, and have your freelancer sign an additional Non-Disclosure Agreement if needed.
                            </p>
                            <hr>
                        </div>

                        <!-- <h4 class="accordion-toggle">7. What if my company wants to hire someone to work as an employee?</h4>
                        <div class="accordion-content">
                            <p>
                                With Upwork Pro, we understand that you may want to hire your freelancer for a full-time employment position with your company. If the freelancer is open to that arrangement, you can pay Upwork a fee for sourcing the freelancer for your team. The sourcing fee will be the greater of $10,000 or 20% of the freelancer’s annual earnings, as calculated by their current hourly rate at 40 hours per week for a full year.<br>Another option without a sourcing fee is to enroll in Upwork Payroll, which supports U.S. workers classified as employees. Read more about this service 

                            </p>
                            <hr>
                        </div> -->

                    </div>

                </div>
                <div class="col-md-2 col-sm-2"></div>
            </div>
        </div><br><br>
        
    </div>
</template>

<script>
import navbar from '../components/navbar';


export default {
    components: { navbar,
    },
    mounted() {
        $(document).ready(function() {
            $('.accordion').find('.accordion-toggle').click(function() {
                $(this).next().slideToggle('600');
                $(".accordion-content").not($(this).next()).slideUp('600');
            });
            $('.accordion-toggle').on('click', function() {
                $(this).toggleClass('active').siblings().removeClass('active');
            });
        });
    }
}
</script>

<style scoped>
    .__bepro{
        font-size: 50px;
        font-weight: 600;
        line-height: 1.2;
        color: #ffffff;
    }

    .__term {
        font-size: 14px;
        line-height: 1.65;
        color: #000000;
        margin-top: 18px;
    }

    .accordion{
        width:100%; 
        margin: 0 auto;
    }
    .accordion-toggle {
        border-bottom: 1px solid #cccccc;
        cursor: pointer;
        margin: 0;
        padding: 20px 0;
        position: relative;
    }
    .accordion-toggle.active:after{
        content:"";
        position:absolute;
        right:0;top:17px;
        width:0;height:0;
        border-bottom:5px solid #0000ef;
        border-left:5px solid #fff;
        border-right:5px solid #fff;
    }
    .accordion-toggle:before{
        content:"";
        position:absolute;
        right:0;
        top:25px;
        width:0;
        height:0;
        border-top:5px solid #000;
        border-left:5px solid #fff;
        border-right:5px solid #fff;
    }
    .accordion-toggle.active:before{
        display:none;
    }
    .accordion-content {
        display: none;
        font-size: 16px;
        padding: 20px 0;
        text-align: justify;
    }
    .accordion-toggle.active {
        color: #0000ef;
    }
</style>



// WEBPACK FOOTER //
// src/components/faq.vue